<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="active">
          <el-tab-pane label="绩效管理" name="main">
            <div class="lr between">
              <div style="display: flex;justify-content: flex-start;">
                <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                          suffix-icon="el-icon-search" @change="search(true)" style="width: 217px;"/>
                <el-date-picker
                  class="ml20"
                  v-model="table.query.createDate"
                  type="month"
                  placeholder="请选择月份"
                  value-format="yyyy-MM"
                  @change="search()">
                </el-date-picker>
              </div>
              <div style="display: flex;justify-content: flex-end;">
                <el-button type="primary" size="small" @click="openDialog(null, false)"
                           icon="el-icon-plus">新增
                </el-button>
                <div style="display: flex;justify-content: flex-end;">
                  <el-button type="primary" size="small" @click="handleExcelExport"
                             icon="el-icon-download" class="ml20">导出
                  </el-button>
                </div>
              </div>
            </div>
            <div class="main" style="margin-top: 20px;">
              <el-table :data="table.data" height="600px" border
                        :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
                <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                                 align="center"/>
                <el-table-column show-overflow-tooltip label="类型" align="center"
                                 prop="type">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == 0">公司</span>
                    <span v-if="scope.row.type == 1">合作方</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="房源方" align="center"
                                 prop="ownerName"></el-table-column>
                <el-table-column show-overflow-tooltip label="销售" align="center"
                                 prop="sale"></el-table-column>
                <el-table-column show-overflow-tooltip label="金额" align="center"
                                 prop="amount"></el-table-column>
                <el-table-column show-overflow-tooltip label="公司提成" align="center"
                                 prop="commissionAmount"></el-table-column>
                <el-table-column label="凭证" align="center"
                                 prop="voucherImages">
                  <template slot-scope="scope">
                    <div v-if="scope.row.voucherImages">
                      <image-dialog :urls="scope.row.voucherImages"></image-dialog>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="审核状态" align="center"
                                 prop="status">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status == 0">待审核</span>
                    <span v-if="scope.row.status == 1">通过</span>
                    <span v-if="scope.row.status == 2">驳回</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="计入单量" align="center"
                                 prop="inRecord">
                  <template slot-scope="scope">
                    <span v-if="scope.row.inRecord">是</span>
                    <span v-else>否</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="单量" align="center"
                                 prop="totalRecords"></el-table-column>
                <el-table-column show-overflow-tooltip label="签约月数" align="center"
                                 prop="month"></el-table-column>
                <el-table-column show-overflow-tooltip label="创建时间" align="center"
                                 prop="createDate"></el-table-column>
                <el-table-column show-overflow-tooltip label="备注" align="center"
                                 prop="description"></el-table-column>
                <el-table-column show-overflow-tooltip label="操作" width="210" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>
                    <el-button type="text" @click="approval(scope.row, 1)" v-if="scope.row.status == 0">通过</el-button>
                    <el-button type="text" style="color: #ff4949;" @click="approval(scope.row, 2)"
                               v-if="scope.row.status == 0">驳回
                    </el-button>
                    <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="lr end" style="margin-top: 20px;">
              <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                             layout="total, prev, pager, next" @current-change="currentPageChange"/>
            </div>
          </el-tab-pane>
          <el-tab-pane label="按月统计" name="month">
            <performance-month></performance-month>
          </el-tab-pane>
          <el-tab-pane label="按年统计" name="year">
            <performance-year></performance-year>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog :visible.sync="performanceRecordDialog.visible" :close-on-click-modal="false" width="30%"
               :title="!isEdit ? '新增销售业绩' : '编辑销售业绩'">
      <el-form ref="performanceRecordForm" label-position="right" label-width="120px"
               :model="performanceRecordDialog.formData"
               :rules="rules" style="height: 550px;overflow-y: auto;padding: 0 20px;">
        <el-form-item label="销售：" prop="saleId" v-if="!this.isSale">
          <el-select filterable v-model="performanceRecordDialog.formData.saleId" placeholder="请选择销售" clearable
                     style="width: 100%;">
            <el-option v-for="item in sales" :key="item.id" :value="item.id"
                       :label="item.nickname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" prop="type">
          <el-radio-group v-model="performanceRecordDialog.formData.type">
            <el-radio :label="0">公司</el-radio>
            <el-radio :label="1">合作方</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="凭证：" prop="voucherImages">
          <el-upload
            action="/group1/upload?output=json"
            list-type="picture-card"
            :limit="performanceRecordDialog.formData.type == 0 ? 1 : 2"
            :file-list="imageList"
            :on-success="handleImageSuccess"
            :on-remove="handleImageRemove"
            accept="image/gif,image/jpeg,image/png,.gif,.jpeg,.jpg,.png">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="金额：" prop="amount">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="performanceRecordDialog.formData.amount"/>
        </el-form-item>
        <el-form-item label="公司提成：" v-if="performanceRecordDialog.formData.type == 0">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="performanceRecordDialog.formData.commissionAmount"/>
        </el-form-item>
        <el-form-item label="计入单量：" prop="inRecord">
          <el-radio-group v-model="performanceRecordDialog.formData.inRecord">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单量：" prop="totalRecords">
          <el-input-number :min="0" style="width: 100%" v-model="performanceRecordDialog.formData.totalRecords"/>
        </el-form-item>
        <el-form-item label="签约月数：" prop="month">
          <el-input-number :min="1" :max="12" style="width: 100%" v-model="performanceRecordDialog.formData.month"/>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注"
                    v-model="performanceRecordDialog.formData.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="performanceRecordDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData} from "@/api/performanceRecord";
import {getList as getSales} from "@/api/user";
import PerformanceMonth from "@/components/PerformanceMonth";
import PerformanceYear from "@/components/PerformanceYear";
import ImageDialog from "@/components/ImageDialog";

export default {
  components: {
    PerformanceMonth,
    PerformanceYear,
    ImageDialog
  },
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          createDate: '',
          keyWord: '',
          saleId: ''
        },
        total: 0,
        data: []
      },
      performanceRecordDialog: {
        formData: {
          type: 0,
          saleId: '',
          sale: '',
          saleAvatar: '',
          voucherImages: '',
          amount: 0,
          commissionAmount: 0,
          description: '',
          inRecord: false,
          totalRecords: 0,
          month: 1
        },
        visible: false
      },
      rules: {
        type: [
          {trigger: 'change', required: true, message: '请选择类型'}
        ],
        saleId: [
          {trigger: 'change', required: true, message: '请选择销售'}
        ],
        voucherImages: [
          {trigger: 'change', required: true, message: '请上传凭证'}
        ],
        inRecord: [
          {trigger: 'change', required: true, message: '请选择是否计入单量'}
        ],
        totalRecords: [
          {trigger: 'change', required: true, message: '请输入单量'}
        ],
        month: [
          {trigger: 'change', required: true, message: '请输入签约月数'}
        ],
        commissionAmount: [
          {trigger: 'change', required: true, message: '请输入公司提成'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false,
      sales: [],
      imageList: [],
      active: 'main',
      userInfo: {},
      isSale: false
    }
  },
  watch: {
    'performanceRecordDialog.formData.type'(newVal) {
      if (newVal == 0 && this.imageList.length > 1) {
        this.imageList.splice(1, 1)
        this.performanceRecordDialog.formData.voucherImages = this.imageList.map(item => item.url).join(',')
      }
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.isSale = this.userInfo.roleIds.indexOf('1') == -1 && this.userInfo.roleIds.indexOf('4') == -1
    this.search(true)
    this.getSales()
  },
  methods: {
    getSales() {
      const params = {
        roleId: '3'
      }
      getSales(params).then(response => {
        if (response.code == 200) {
          this.sales = response.data
        }
      })
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
        this.table.query.createDate = ''
      }
      if (this.isSale) {
        this.table.query.saleId = this.userInfo.id
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        createDate: this.table.query.createDate,
        saleId: this.table.query.saleId,
        pcUse: true
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改销售业绩
    saveOrUpdateData() {
      this.loading = true
      this.$refs['performanceRecordForm'].validate(async (valid) => {
        if (valid) {
          if (this.isSale) {
            this.performanceRecordDialog.formData.saleId = this.userInfo.id
          }
          this.performanceRecordDialog.formData.sale = this.sales.filter(item => item.id == this.performanceRecordDialog.formData.saleId)[0].nickname
          this.performanceRecordDialog.formData.saleAvatar = this.sales.filter(item => item.id == this.performanceRecordDialog.formData.saleId)[0].imageUrl
          saveOrUpdateData(this.performanceRecordDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.performanceRecordDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      this.imageList = []
      if (!isEdit) {
        // 重置数据
        this.performanceRecordDialog.formData = {
          type: 0,
          saleId: '',
          sale: '',
          saleAvatar: '',
          voucherImages: '',
          amount: 0,
          commissionAmount: 0,
          description: '',
          inRecord: false,
          totalRecords: 0,
          month: 1
        }
      } else {
        if (data.voucherImages) {
          const imageUrls = data.voucherImages.split(',')
          for (let i = 0; i < imageUrls.length; i++) {
            this.imageList.push({
              uid: i,
              url: imageUrls[i]
            })
          }
        }
        this.performanceRecordDialog.formData = JSON.parse(JSON.stringify(data))
        this.performanceRecordDialog.formData.saleId = parseInt(this.performanceRecordDialog.formData.saleId)
      }
      this.performanceRecordDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.performanceRecordForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除销售业绩
    deleteData(id) {
      this.$confirm('此操作将永久删除销售业绩信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleImageSuccess(response, file) {
      this.imageList.push({
        uid: file.uid,
        url: response.url
      })
      this.performanceRecordDialog.formData.voucherImages = this.imageList.map(item => item.url).join(',')
    },
    handleImageRemove(file) {
      this.imageList = this.imageList.filter(item => item.uid != file.uid)
      if (this.imageList && this.imageList.length > 0) {
        this.performanceRecordDialog.formData.voucherImages = this.imageList.map(item => item.url).join(',')
      } else {
        this.performanceRecordDialog.formData.voucherImages = ''
      }
    },
    approval(row, status) {
      let title = '通过'
      if (status == 2) {
        title = '驳回'
      }
      this.$confirm('确认' + title + '此条销售业绩?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = status
        saveOrUpdateData(row).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        })
      })
    },
    //导出
    handleExcelExport() {
      if (this.isSale) {
        window.open(`/hrApi/performanceRecord/export?createDate=${this.table.query.createDate}&saleId=${this.userInfo.id}&token=${localStorage.getItem('token')}`);
      } else {
        window.open(`/hrApi/performanceRecord/export?createDate=${this.table.query.createDate}&token=${localStorage.getItem('token')}`);
      }
      this.$message.success("导出成功！");
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/performanceRecord.vue